export function parseCertificationMonth(
  certificationid: string,
  windowStart?: string
): string {
  const match = certificationid.match(/^MNTH(\d{4})(\d{2})$/);
  if (match) {
    const [, year, month] = match;
    return new Date(Number(year), Number(month) - 1).toLocaleDateString(
      "en-US",
      { month: "long", year: "numeric" }
    );
  }
  if (windowStart) {
    return new Date(windowStart + "T00:00:00").toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    });
  }
  return certificationid;
}

export function normalizeStatus(status: string | undefined): string {
  if (!status) return "-";
  if (status === "Open") return "Uncertified";
  return status;
}
